<template>
	<transition	name="fade" mode="in-out">
		<ul class="site-nav-admin__dropdown" v-show="data.isOpened">
			<template v-for="(item, index) in data.links">
				<li class="site-nav-admin__dropdown-item" :key="index" v-if="item.url && item.label">
					<router-link class="site-nav-admin__dropdown-link" ref="nav-link" :to="{ name: item.url, params: { id: user.id } }">
						<SvgIcon
							v-if="item.iconMenuItem"
							class="site-nav-admin__dropdown-icon"
							:iconName="item.iconMenuItem"
						/>
						{{ item.label }}
					</router-link>
				</li>
				<!-- Logout -->
				<li class="site-nav-admin__dropdown-item site-nav-admin__dropdown-item--logout" :key="index"  v-else-if="item.label === 'Log out'">
					<SvgIcon
						class="site-nav-admin__dropdown-icon"
						:iconName="item.iconMenuItem"
					/>
					<a class="site-nav-admin__dropdown-link" ref="nav-link" href="javascript:" @click="logout">
						{{ item.label }}
					</a>
				</li>
			</template>
		</ul>
	</transition>
</template>

<script>
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';

export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	components: {
		SvgIcon
	},
	computed: {
		user() {
			return this.$store.getters.getUser;
		}
	},
	methods: {
		logout() {
			this.$store.dispatch('logout');
			localStorage.removeItem('filter-property');
			localStorage.removeItem('filter-customers');
			localStorage.removeItem('filter-customers');
			localStorage.removeItem('tab');
		}
	}
};
</script>

<style lang="scss" scoped>
.ico-angle-down {
	padding-right: 6px;
	color: $dodger-blue;
	transition: $dur $ease;
	font-size: 12px;
	padding-left: 11px;
}

.site-nav-admin__overlay {
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	width: 100%;
	height: 100vh;
	z-index: 1;
	background-color: transparent;
	transition: $dur $ease;
	display: none;

	&.showOverlay {
		display: block;
	}
}

a {
	text-decoration: none;
}

.site-nav {
	line-height: 2;
	height: 100%;
	display: flex;
	justify-content: space-between;
	width: 100%;

	@include mq($xl) {
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		text-align: left;
		height: auto;
	}
}

.site-nav__list {
	list-style: none;
	margin: 0;
	padding: 0;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	align-items: $dur $ease;

	@include mq($xl) {
		display: block;
		width: 100%;
	}

	.site-nav__item {
		&.active-link {
			background-color: $link-water;
			border-radius: 14px;

			@include mq($xl) {
				padding: 25px 20px;
				padding-left: 30px;
				border-radius: 0;
			}

			.site-nav__link {
				color: $madison;
			}

			.site-nav__item-icon {
				/deep/
				.svg {
					color: $madison;
					fill: $madison;
				}
			}
		}
	}
}

.site-nav__list-user {
	@include mq($xl) {
		width: 100%;
	}

	.site-nav__item {
		padding: 14px 16px;
		//transition: $dur $ease;
		display: flex;

		@include mq($xl) {
			width: 100%;
			padding: 14px 16px;
			border-radius: 0;
		}

		&::after {
			display: none;
		}

		&:first-of-type {
			padding: 0 13px;

			@include mq($xl) {
				padding: 20px 0 20px 30px;
				order: 1;
			}

			&::before {
				display: none;
			}

			.site-nav__item-icon {
				font-size: 21px;
				padding-right: 14px;

				@include mq($xl) {
					padding-right: 12px;
					font-size: 18px;
				}
			}
		}

		&:nth-child(2) {
			@include mq($xl) {
				order: 3;

				.site-nav__item-icon {
					padding-right: 0;
					padding-left: 30px;
				}
			}
		}

		&:last-of-type {
			padding-left: 8px;
			margin-left: 22px;
			padding-right: 0;

			@include mq($xl) {
				padding-bottom: 23px;
				padding-left: 0;
				margin-left: 0;
				order: 2;
			}

			.site-nav__link,
			.site-nav__item-icon {
				color: $shuttle-gray;
			}

			@include hover {
				.site-nav__link,
				.site-nav__item-icon {
					color: $dodger-blue;
				}
			}

			.site-nav__item-icon {
				padding-right: 12px;
			}
		}

		.site-nav__link {
			font-family: $font-main;
			font-weight: 500;
			font-size: 14px;
			padding-left: 6px;

			@include mq($xl) {
				font-weight: normal;
				font-size: 16px;
			}
		}
	}
}

.site-nav__item {
	position: relative;
	display: flex;
	position: relative;
	//height: 100%;
	align-items: center;
	transition: $dur $ease;
	padding: 14px 16px;
	border-radius: 14px;

	&:first-of-type {

		&::before {
			content: '';
			position: absolute;
			height: 100%;
			width: 1px;
			background-color: $grey-light;
			left: 0;
			top: 0;
			z-index: 2;
		}
	}

	&:nth-child(2) {
		.site-nav__item-icon {
			font-size: 19px;
		}
	}

	&::after {
		content: '';
		position: absolute;
		height: 100%;
		width: 1px;
		background-color: $grey-light;
		right: 0;
		top: 0;
		z-index: 2;
	}

	@include mq($xl + 1, 'min') {

		&.has-sub-menu {
			padding-right: 20px;
		}
	}

	@include mq($xl) {
		margin: 0;
		padding: 25px 20px;
		border-radius: 0;
		padding-left: 30px;
		border-bottom: 1px solid rgba( #9e9e9e, .3);
		overflow: hidden;
		transition: $dur $ease;
	}

	@include hover {
		cursor: pointer;

		.site-nav__link {
			color: $dodger-blue;
		}

		.site-nav__link--no-hover {
			color: $shuttle-gray;

			.site-nav__item-icon {
				color: $shuttle-gray;
			}
		}

		.ico-angle-down {
			color: $dodger-blue;
		}

		.site-nav__item-icon {
			color: $dodger-blue;
		}

		/deep/ {
			> .site-subnav__list {
				transform: translateY(0);
				opacity: 1;
				visibility: visible;
			}
		}
	}

	&.site-nav__item--dropdown {
		@include mq($xl) {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			padding-bottom: 0 !important;
			border-bottom: none;
		}
		
		@include hover {
			background-color: transparent !important;
		}
	}
}

.site-nav__icon {
	color: $white;
	right: 0;
	@include center(y);

	@include mq($xl) {
		z-index: 10;
		cursor: pointer;
		font-size: 20px;
		padding: 5px;
		top: 1px;
		transform: none;
		transition: $dur $ease;

		&.is-active {
			transform: rotate(180deg);
		}
	}
}

.site-nav__link {
	position: relative;
	text-decoration: none;
	font-family: $font-main;
	font-size: 16px;
	line-height: 1.2;
	color: $shuttle-gray;
	transition: $dur $ease;
	height: 100%;
	display: flex;
	align-items: center;
	padding: 0;

	&.user-name {
		@include mq($lg) {
			display: none;
		}
	}

	@include mq($xl) {
		color: $fiord;
	}

	&.nuxt-link-active {
		color: $red;
	}

	&.user-name {
		@include mq($xl) {
			display: none;
		}
	}
}

.site-na__item-icon {
	svg {
		color: $black;
	}
}

.site-nav-icon {
	display: block;
	color: $black;
	font-size: 14px;
	background-color: $red;
	width: 17px;
	height: 17px;
}

.site-nav__item-icon {
	padding-right: 6px;
	color: $shuttle-gray;
	transition: $dur $ease;
	font-size: 16px;

	@include mq($xl) {
		font-size: 14px;
		padding-right: 12px;
		color: $fiord;
	}
}

/*users link*/
.site-nav__list-user {
	list-style: none;
	margin: 0;
	padding: 0;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	height: 100%;

	@include mq($xl) {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;
		padding-bottom: 20px;
	}
}

.site-header {
	&.is-sticky {

		.site-nav__list {
			transform: scale(0.99);
			transform-origin: left;
			transition: $dur $ease;

			@include mq($xl) {
				transform: scale(1);
			}
		}
	}
}

//Dropdown
.site-nav-admin__dropdown {
	position: absolute;
	background-color: $white;
	padding: 18px 0;
	top: 88%;
	min-width: 209px;
	width: 100%;
	right: 0;
	box-shadow: 0 0px 7px -2px rgba(0, 0, 0, 0.75);
	z-index: 2000;

	@include mq($xl) {
		top: 64px;
		position: fixed;
		right: 50px;
		width: 209px;
	}

	@include mq($lg) {
		width: 170px;
		padding: 10px 0;
	}

	@include mq($sm) {
		right: 50px;
	}

	&::before {
		content: '';
		position: absolute;
		right: 22px;
		top: -10px;
		width: 24px;
		height: 24px;
		background-color: $white;
		box-shadow: 0 0px 7px -2px rgba(0, 0, 0, 0.75);
		transform: rotate(45deg);
		z-index: 0;
	}
	&::after {
		content: '';
		position: absolute;
		right: 0;
		top: 0;
		width: 55px;
		height: 24px;
		background-color: $white;
		z-index: 0;
	}
}

.site-nav-admin__dropdown-link {
	font-family: $font-main;
	font-size: 16px;
	line-height: 1.2;
	color: $shuttle-gray;
	transition: $dur $ease;
	z-index: 10;
	position: relative;
	display: flex;

	@include mq($xl) {
		font-size: 14px;
		align-items: end;
	}
}

.site-nav-admin__dropdown-icon {
	color: $fiord;
	transition: $dur $ease;
	font-size: 22px;
	padding-right: 9px;

	@include mq($lg) {
		font-size: 17px;
		height: 17px;
	}

	svg {
		height: 20px;

		@include mq($lg) {
			height: 17px;
		}
	}
}

.site-nav-admin__dropdown-item {
	display: flex;
	align-items: center;
	padding: 0 27px 19px;

	@include mq($xl) {
		padding: 10px 20px;
	}

	@include hover {
		.site-nav-admin__dropdown-link,
		.site-nav-admin__dropdown-icon {
			color: $dodger-blue;
		}
	}

	&:last-of-type {
		@include hover {
			.site-nav-admin__dropdown-link,
			.site-nav-admin__dropdown-icon {
				color: $dodger-blue;
			}
		}

		.site-nav-admin__dropdown-link {
			color: $red;
		}

		.site-nav-admin__dropdown-icon {
			color: $orange;
		}
	}

	&:nth-child(2) {
		.site-nav-admin__dropdown-icon {
			font-size: 20px;

			@include mq($lg) {
				font-size: 17px;
			}
		}
	}
}

.site-nav-admin__dropdown-item--logout {
	border-top: 1px solid $grey-light;
	padding-top: 20px;

	@include mq($xl) {
		padding: 15px 20px;
	}
}

.chevron-active {
	transform: rotateX(180deg);
	will-change: transform;
}

.user-mobile {
	display: none;
	font-weight: 500;

	@include mq($md) {
		display: block;
	}
}

.site-nav-admin__img {
	width: 36px;
	height: 36px;
	border-radius: 50%;
	object-fit: cover;

	@include mq($md) {
		width: 30px;
		height: 30px;
	}
}
</style>
